import { useField, useFormikContext } from 'formik';
import { useEffect, useRef, useState } from 'react';
import RichTextEditor from '../rich-text-editor';

const EditorComponent = (props: any) => {
  const [field, meta] = useField(props.name);
  const { setFieldValue } = useFormikContext<any>();
  const [richDescription, setRichDescription] = useState('');
  const editorRef = useRef<any>(null);

  useEffect(() => {
    if (meta.value) setRichDescription(meta.value);
  }, [meta.value]);

  return (
    <RichTextEditor
      ref={editorRef}
      height={300}
      value={richDescription}
      onChange={(content) => {
        setRichDescription(content);
        setFieldValue(field.name, content);
      }}
    />
  );
};

export default EditorComponent;
